import { render } from "./my-spacer.vue?vue&type=template&id=4baf880f"
const script = {}

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__